<template>
	<div>
		<div class="banxx" style="background:url('/images/yrxm.jpg') no-repeat center center; background-size:cover">
			<div class="main">
				<div class="text">
					<h3>关于易格</h3>
					<p>首页 / 关于易格</p>
				</div>
			</div>
		</div>
		
		<vue-menu :menu="menu" title="关于易格"></vue-menu>
	</div>
</template>

<script>
	import vueMenu from '@/components/vue-menu'
	export default {
		data() {
			return {
				menu: [{
					title: '公司简介',
					'path': 'company'
				},
				// {
				// 	title: '荣誉资质',
				// 	'path': 'honor'
				// },
				{
					title: '合作院校',
					'path': 'school'
				}, {
					title: '新闻动态',
					'path': 'news'
				}, {
					title: '发展历程',
					'path': 'history'
				}, {
					title: '联系我们',
					'path': 'contact'
				}],
				active: 'company'
			}
		},
		watch: {
			$route(val) {
				this.active = val.path.substring(val.path.lastIndexOf('/') + 1)
			}
		},
		created() {
			let path = this.$route.path
			this.active = path.substring(path.lastIndexOf('/') + 1)
		},
		methods: {

		},
		components: {
			vueMenu
		}
	}
</script>

<style scoped >
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	hr,
	dt,
	dd,
	dl {
		font-size: 14px;
		margin: 0;
		padding: 0;
		font-weight: normal;
	}

	.banxx {
		height: 150px;
	}
	
	.main {
		height: 100%;
		max-width: 1220px !important;
		margin: 0 auto !important;
		padding: 0px 10px;
	
	}
	
	.text {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.text h3 {
		font-size: 34px;
		color: #333;
		font-weight: normal;
		margin: 0;
	}
		
	.text p {
		color: #333;
		font-size: 16px;
		margin-top: 10px;
	}

	 
</style>
